<section class="body">
  <header class="header" (escapeDialog)="handleCloseDialog()">
    <div class="header-title">
      <span class="title-prefix">{{ title }}</span>
    </div>
  </header>

  <div class="body-wrapper">
    <p class="subtitle">Selecciona objetos para descarga agrupada.</p>

    <div class="sections-tree">
      <div class="section" *ngFor="let section of config">
        <button
          class="section-toggle"
          type="button"
          [disabled]="isSectionDisabled(section)"
          (click)="toggleSection(section)"
        >
          <bdr-icon
            class="section-toggle-icon"
            [icon]="isSectionExpanded(section) ? 'ico-down' : 'ico-next'"
            size="12px"
          ></bdr-icon>
          <span class="section-label">{{ section.label }}</span>
        </button>

        <div class="subsections" *ngIf="isSectionExpanded(section)">
          <div class="subsection" *ngFor="let subsection of section.subsections">
            <label class="subsection-label">
              <input
                type="checkbox"
                [checked]="isSubsectionChecked(section, subsection)"
                [indeterminate]="isSubsectionIndeterminate(section, subsection)"
                [disabled]="isSubsectionDisabled(section, subsection)"
                (change)="onSubsectionToggle(section, subsection, $event.target.checked)"
              />
              <span>{{ subsection.label }}</span>
            </label>

            <div class="items">
              <label class="item-label" *ngFor="let item of subsection.items">
                <input
                  type="checkbox"
                  [checked]="isItemSelected(section, subsection, item)"
                  [disabled]="isItemDisabled(section, subsection, item)"
                  (change)="onItemToggle(section, subsection, item, $event.target.checked)"
                />
                <span>{{ item.label }}</span>
                <span class="item-hint" *ngIf="item.separateDownload">(descarga separada)</span>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<footer class="footer-wrapper">
  <div class="footer">
    <div class="footer-actions">
      <bdr-button class="btn-save" size="small" (click)="handleCloseDialog()">Cancelar</bdr-button>
      <bdr-button
        class="btn-save"
        [ngClass]="{ 'bdr-btn-disabled': !hasSelectedItems() }"
        primary
        size="small"
        (click)="handleDownload()"
        >Descargar</bdr-button
      >
    </div>
  </div>
</footer>
